import Vue from 'vue'
import VueRouter from 'vue-router'


const Home = ()=> import('../modules/home/Home.vue')
const Main = ()=> import('../modules/home/modules/Main.vue')
const BlogHome = ()=> import('../modules/home/modules/Blog.vue')
const BlogPost = ()=> import('../modules/home/modules/BlogPost.vue')
const terminos_condiciones = ()=> import('../modules/home/modules/terminos_condiciones.vue')
const politica_privacidad = ()=> import('../modules/home/modules/politica_privacidad.vue')


const Auth = ()=> import('../modules/auth/Auth.vue')
const Login = ()=> import('../modules/auth/modules/login/Login.vue')
const Register = ()=> import('../modules/auth/modules/register/Register.vue')
const ActivateAccount = ()=> import('../modules/auth/modules/activate-account/ActivateAccount.vue')
const VerifyEmail = ()=> import('../modules/auth/modules/verify-email/VerifyEmail.vue')
const ForgotPassword = ()=> import('../modules/auth/modules/forgot-password/ForgotPassword.vue')
const ChangePasswordAuth = ()=> import('../modules/auth/modules/change-password/ChangePassword.vue')


const Cms = ()=> import('../modules/cms/Cms.vue')
const Dashboard = ()=> import('../modules/cms/modules/dashboard/Dashboard')
const ChangePassword = ()=> import('../modules/cms/modules/change_password/ChangePassword.vue')
const Customer = ()=> import('../modules/cms/modules/customer/Customer.vue')
const Packages = ()=> import('../modules/cms/modules/packages/Packages.vue')
const Notification = ()=> import('../modules/cms/modules/notification/Notification.vue')
const PaymentMethods = ()=> import('../modules/cms/modules/payment-methods/PaymentMethods.vue')
const GnralSetting = ()=> import('../modules/cms/modules/gnral-setting/GnralSetting.vue')
const Blog = ()=> import('../modules/cms/modules/blog/Blog.vue')
const CreatePost = ()=> import('../modules/cms/modules/blog/components/Create')
const EditPost = ()=> import('../modules/cms/modules/blog/components/Edit')
const Sends = ()=> import('../modules/cms/modules/sends/Sends')
const AccountsApi = ()=> import('../modules/cms/modules/accounts-api/AccountsApi.vue')
const Terms = ()=> import('../modules/cms/modules/terms/Terms.vue')


const AccountUser = ()=> import('../modules/account-user/AccountUser')
const Send = ()=> import('../modules/account-user/modules/send/Send.vue')
const Perfil = ()=> import('../modules/account-user/modules/perfil/Perfil.vue')
const Setting = ()=> import('../modules/account-user/modules/setting/Setting.vue')
const NotificationUser = ()=> import('../modules/account-user/modules/notification/Notification.vue')
const MySends = ()=> import('../modules/account-user/modules/my-sends/MySends.vue')


import UserService from '@/shared/services/UserService'


Vue.use(VueRouter)

const routes = [
  
  { 
    path: '', 
    name: 'home',
    component: Home,

    children: [
      {
        path: '',
        name: 'main',
        component: Main
      },

      {
        path: 'blog',
        name: 'blog',
        component: BlogHome
      },

      {
        path: 'post/:id',
        name: 'post',
        component: BlogPost
      },

      {
        path: 'terminos_condiciones',
        name: 'terminos_condiciones',
        component: terminos_condiciones
      },

      {
        path: 'politica_privacidad',
        name: 'politica_privacidad',
        component: politica_privacidad
      } 
    ] 
  },

  {
    path: '/autenticacion',
    name: 'autenticacion',
    component: Auth,

    children: [
      {
        path: '',
        name: 'login',
        component: Login
      },

      {
        path: 'registrar',
        name: 'registrar',
        component: Register
      },

      {
        path: 'verificar-correo/:email',
        name: 'verify-email',
        component: VerifyEmail
      },

      {
        path: 'activar-cuenta/:email/:token',
        name: 'activate-account',
        component: ActivateAccount
      },

      {
        path: 'recuperar',
        name: 'forgot-password',
        component: ForgotPassword
      },

      {
        path: 'restaurar-clave/:email/:token',
        name: 'change-password',
        component: ChangePasswordAuth
      }
    ]
  },

  {
    path: '/cms',
    name: 'cms',
    component: Cms,
    meta: { requiresAuth: true },

    children: [
      {
        path: '',
        name: 'Tablero',
        component: Dashboard
      },

      {
        path: 'cambiar_clave',
        name: 'change_password',
        component: ChangePassword
      },

      {
        path: 'clientes',
        name: 'customer',
        component: Customer
      },

      {
        path: 'paqueterias',
        name: 'packages',
        component: Packages
      },

      {
        path: 'notificaciones',
        name: 'notification',
        component: Notification
      },

      {
        path: 'metodos-pago',
        name: 'payment-methods',
        component: PaymentMethods
      },

      {
        path: 'configuracion-general',
        name: 'gnaral-setting',
        component: GnralSetting
      },

      {
        path: 'blog',
        name: 'blog',
        component: Blog
      },

      {
        path: 'crear-post',
        name: 'create-post',
        component: CreatePost
      },

      {
        path: 'editar-post/:id',
        name: 'edit-post',
        component: EditPost
      },

      {
        path: 'envios',
        name: 'sends',
        component: Sends
      },

      {
        path: 'cuentas-api',
        name: 'accounts-api',
        component: AccountsApi
      },

      {
        path: 'terminos-privacidad',
        name: 'terms-privacy',
        component: Terms
      }

    ]
  },

  {
    path: '/usuario',
    name: 'account-user',
    component: AccountUser,
    meta: { requiresAuth: true },

    children: [
      {
        path: '',
        name: 'send',
        component: Send
      },

      {
        path: 'perfil',
        name: 'perfil',
        component: Perfil
      },

      {
        path: 'configuracion',
        name: 'setting',
        component: Setting
      },

      {
        path: 'notificaciones',
        name: 'notification',
        component: NotificationUser
      },

      {
        path: 'envios',
        name: 'my-sends',
        component: MySends
      },
    ]
  },

]

const router = new VueRouter({
  routes,

  scrollBehavior (to, from, savedPosition) 
  {
    if(savedPosition) 
      return savedPosition
    else 
      return { x: 0, y: 0 }
  }
})


router.beforeEach(async (to, from, next) => 
{
  if(to.matched.some(route => route.meta.requiresAuth))
  {
    let destRoute = to.path.split('/')[1]

    if(localStorage.getItem('token') != undefined)
    {
      const resp = await UserService.getUser()
      const user = resp.data

      console.log(resp.data)

      if(user != null)
        next()
      else
        location.href = Vue.prototype.domain

    }else 
      location.href = Vue.prototype.domain

  }else
    next()
})



export default router
